import { createContext } from 'react';
import type { UserInfo } from '@/lib/types';

export interface AuthContextValue {
  isAuthenticated: boolean;
  user: UserInfo | null;
  loading: boolean;
  login: (token: string, user: UserInfo) => void;
  logout: () => void;
}

export const AuthContext = createContext<AuthContextValue | undefined>(undefined);
